import { render, staticRenderFns } from "./dashlets-settings-modal.vue?vue&type=template&id=1705eb96"
import script from "./dashlets-settings-modal.vue?vue&type=script&lang=js"
export * from "./dashlets-settings-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports